/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon16Light = forwardRef('XCircleIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.68 4.973a.5.5 0 1 0-.707.707l1.82 1.82-1.82 1.82a.5.5 0 0 0 .707.707l1.82-1.82 1.82 1.82a.5.5 0 1 0 .707-.707L8.207 7.5l1.82-1.82a.5.5 0 0 0-.707-.707L7.5 6.793l-1.82-1.82Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 1a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" })));
});
